import type { Project } from "./projectFile";

export interface EventSeed {
  /** The event's name, from the project. */
  title: string;
  /** YYYY-MM-DD of the first session, or the first guest arrival. */
  date?: string;
  /** HH:MM of the first session that day. */
  time?: string;
  /** A venue or hotel from the vendor list, else the first session room. */
  venue?: string;
  /** Up to three session titles, for flyers. */
  highlights: string[];
}

const DEFAULT_NAME = "My event";

/** What the card, flyer and calendar tools should start from when a project is open. Null when nothing is loaded. */
export function eventSeed(p: Project): EventSeed | null {
  const d = p.data;
  const name = p.name.trim();
  const hasData = d.sessions.length > 0 || d.guests.length > 0 || d.vendors.length > 0;
  if (!hasData && (!name || name === DEFAULT_NAME)) return null;
  const sessions = [...d.sessions].sort((a, b) => a.day.localeCompare(b.day) || a.start.localeCompare(b.start));
  const first = sessions[0];
  const arrivals = d.guests.map((g) => g.arrival).filter((x): x is string => !!x).sort();
  const venue = d.vendors.find((v) => /venue|accommodation|hotel/i.test(v.category ?? ""))?.name ?? sessions.find((s) => s.room)?.room;
  return {
    title: name || DEFAULT_NAME,
    date: first?.day ?? arrivals[0],
    time: first?.start,
    venue: venue?.trim() || undefined,
    highlights: sessions.slice(0, 3).map((s) => s.title),
  };
}
